import React from 'react';
import { CheckCircle } from 'lucide-react';

interface BarraProgresoProps {
  porcentaje: number;
  porcionesCompletadas: number;
  porcionesTotales: number;
  size?: 'sm' | 'md' | 'lg';
}

const BarraProgreso: React.FC<BarraProgresoProps> = ({
  porcentaje,
  porcionesCompletadas,
  porcionesTotales,
  size = 'md',
}) => {
  const alturas = {
    sm: 'h-1.5',
    md: 'h-2.5',
    lg: 'h-4',
  };

  const altura = alturas[size];

  // Determinar color según el porcentaje
  const getColorClasses = () => {
    if (porcentaje === 100) {
      return 'bg-green-600 dark:bg-green-500';
    } else if (porcentaje >= 75) {
      return 'bg-blue-600 dark:bg-blue-500';
    } else if (porcentaje >= 50) {
      return 'bg-yellow-500 dark:bg-yellow-400';
    } else if (porcentaje >= 25) {
      return 'bg-orange-500 dark:bg-orange-400';
    } else {
      return 'bg-red-500 dark:bg-red-400';
    }
  };

  return (
    <div className="w-full">
      {/* Barra de progreso */}
      <div className="relative">
        <div
          className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full ${altura} overflow-hidden`}
        >
          <div
            className={`${altura} ${getColorClasses()} rounded-full transition-all duration-300 ease-in-out flex items-center justify-end pr-1`}
            style={{ width: `${porcentaje}%` }}
          >
            {porcentaje === 100 && size !== 'sm' && (
              <CheckCircle className="w-3 h-3 text-white" />
            )}
          </div>
        </div>
      </div>

      {/* Texto informativo */}
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-gray-600 dark:text-gray-400">
          {porcionesCompletadas} / {porcionesTotales} porciones
        </span>
        <span
          className={`text-xs font-semibold ${
            porcentaje === 100
              ? 'text-green-600 dark:text-green-400'
              : 'text-gray-700 dark:text-gray-300'
          }`}
        >
          {porcentaje}%
        </span>
      </div>
    </div>
  );
};

export default BarraProgreso;
